import React from "react";
import ChevronLeftIcon from "../icons/ChevronLeft";
import ChevronRightIcon from "../icons/ChevronRight";
import Carousel from "@brainhubeu/react-carousel";
import styled from "styled-components";
import tw from "tailwind.macro";

const ButtonContainer = styled.div.attrs({
  className:
    "hidden lg:flex lg:items-center lg:justify-center h-full absolute m-auto top-0 bottom-0 z-10 bg-white",
})`
  opacity: 0.9;
  ${({ itemWidth }) => itemWidth && `width: calc((100% - ${itemWidth}px) / 2);`}

  ${({ side }) => (side === "right" ? "right: 0" : "left: 0")};
`;

const ArrowButton = styled.button`
  ${tw`hidden lg:flex lg:items-center lg:justify-center h-8 w-8 text-action-blue
    active:outline-none focus:outline-none mr-4 absolute m-auto top-0 bottom-0`}

  ${({ side }) => (side === "right" ? "right: 1rem" : "left: 1rem")};
`;

const CarouselContainer = styled.button`
  ${tw`w-full h-full relative`}

  & > div {
    height: 100%;

    & .BrainhubCarousel {
      height: 100%;
    }
  }
`;

const MediaCarousel = (props) => {
  const {
    value,
    slides,
    centered,
    slidesPerPage,
    itemWidth,
    minDraggableOffset,
    onChange,
    onNextClick,
    onPrevClick,
  } = props;

  return (
    <CarouselContainer>
      <ButtonContainer side={"left"} itemWidth={itemWidth}>
        <ArrowButton side={"left"} onClick={onPrevClick}>
          <ChevronLeftIcon className="h-full w-full focus:shadow-outline text-action-blue" />
        </ArrowButton>
      </ButtonContainer>
      <Carousel
        value={value}
        slides={slides}
        centered={centered}
        slidesPerPage={slidesPerPage}
        itemWidth={itemWidth}
        minDraggableOffset={minDraggableOffset}
        onChange={onChange}
      />
      <ButtonContainer side={"right"} itemWidth={itemWidth}>
        <ArrowButton side={"right"} onClick={onNextClick}>
          <ChevronRightIcon className="h-full w-full focus:shadow-outline text-action-blue" />
        </ArrowButton>
      </ButtonContainer>
    </CarouselContainer>
  );
};

export default MediaCarousel;
